import { Facet, TimelineRangeRule } from '@aipb/gulliver/catalog/model';
import { CheckedProps } from './components/facet-tree/facet-tree.store';
import { FacetTreeNode, TreeFacetItem } from './model';
import { TimelineItem } from './components/timeline-bar-chart/timeline-bar-chart.component';

export function countCheckedFacets(facets: Facet[]) {
  if (!facets) return 0;

  return facets.filter((f) => f.checked).length;
}

export function setDeep(items: CheckedProps, path: string[], value: boolean) {
  path.reduce((a, b, level) => {
    if (typeof a[b] === 'boolean' && level !== path.length - 1) {
      a[b] = {};
      return a[b];
    }

    if (typeof a[b] === 'boolean' && !value && level === path.length - 1) {
      delete a[b];
      return value;
    }

    if (typeof a[b] === 'undefined' && level !== path.length - 1) {
      a[b] = {};
      return a[b];
    }

    if (typeof a[b] === 'undefined' && level === path.length - 1) {
      a[b] = value;
      return value;
    }

    return a[b];
  }, items);
}

export function findFacet(id: string, item: FacetTreeNode): TreeFacetItem {
  let n = null;

  for (let i = 0; i < item.items.length; i++) {
    if (item.items[i].id === id) {
      return item.items[i];
    }
    for (let j = 0; j < item.items[i].items.length; j++) {
      n = findFacet(id, item.items[i].items[j]);

      if (n !== null) {
        return n;
      }
    }
  }

  return n;
}

export function buildQueryPath(input: CheckedProps, item: FacetTreeNode) {
  const result = [];

  function traverse(obj, path = []) {
    const keys = Object.keys(obj);

    for (const key of keys) {
      let facet: TreeFacetItem = findFacet(key, item);
      console.log(key, item);

      if (!facet) continue;

      const value = `${facet.fieldId}:"${facet.value}"`;

      if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        // Recursively traverse nested objects
        traverse(obj[key], [...path, value]);
      } else {
        // If it's a leaf node, collect the path
        const newPath = [...path, value];

        // Check if the previous entry can be grouped
        const existingEntry = result.find(
          (r) => JSON.stringify(r.slice(0, -1)) === JSON.stringify(newPath.slice(0, -1))
        );

        if (existingEntry) {
          // Group keys together in a sub-array
          const groupIndex = result.indexOf(existingEntry);
          result[groupIndex][result[groupIndex].length - 1] = [
            ...result[groupIndex][result[groupIndex].length - 1],
            value
          ];
        } else {
          // Add a new entry
          if (path.length > 0) {
            result.push([...path, [value]]);
          } else {
            result.push([...path, value]);
          }
        }
      }
    }
  }

  traverse(input);
  return result;
}

export function generateSolrQuery(input) {
  function processGroup(group) {
    if (!Array.isArray(group)) {
      return group; // Base case: if it's not an array, return as is
    }

    return group
      .map((item) => {
        if (Array.isArray(item)) {
          return `(${item.map(processGroup).join(' OR ')})`;
        }
        return item;
      })
      .join(' AND ');
  }

  const expressions = input.map((group) => `(${processGroup(group)})`);
  return expressions.join(' OR ');
}

export function trimZeroTimelineItems(arr: TimelineItem[]) {
  // Remove leading elements with zero in the property
  while (arr.length > 0 && arr[0].value === 0) {
    arr.shift();
  }

  // Remove trailing elements with zero in the property
  while (arr.length > 0 && arr[arr.length - 1].value === 0) {
    arr.pop();
  }

  return arr;
}

export function processTimelineRangeRules(differenceInDays: number, rules: TimelineRangeRule[]): TimelineRangeRule {
  for (const rule of rules) {
    const { start, end } = rule;

    if (start !== null && end !== null && differenceInDays >= start && differenceInDays <= end) {
      return rule;
    }

    if (start === null && end !== null && differenceInDays <= end) {
      return rule;
    }

    if (start !== null && end === null && differenceInDays >= start) {
      return rule;
    }
  }

  return null;
}
